<template>
    <div class="fav-wrapper" ref="scrollboxWrapper">
        <div ref="scrollbox">
            <h3 class="favorite-title">收藏</h3>
            <div class="fav-list" v-if="ajaxDone && favList.length">
                <div class="fav-list-item" v-for="(favs, index) in favList" :key="index">
                    <div class="favs-container" :ref="'favs'">
                        <div class="favs" @click="goKBDetail(favs)" @touchstart="touchStart(index)" @touchmove="touchMove(index)" @touchend="touchEnd(index)">
                            <h3 class="fav-tit" v-text="favs.Name"></h3>
                            <p class="fav-content" v-text="favs.Content" v-if="favs.Content"></p>
                        </div>
                        <div class="fav-cancle" @click="UpdateFav(favs.KBInfoId,index)">删除</div>
                    </div>
                </div>
                <!-- <div class="no-more-item">

                </div> -->
                <loading-more></loading-more>
            </div>
        </div>
        <div class="fav-empty" v-if="ajaxDone && !favList.length">
            暂无内容
        </div>
    </div>
</template>
<script>
import { FAV } from '../../api'
import loadingMore from '@/components/loadingMore'
import store from '@/store/index'
export default {
    name:'favorites',
    components:{loadingMore},
    data(){
        return{
            scrollTop:0,
            ajaxDone:false,
            favList:[],
            startX:0, //初始X轴位置
            startY:0, //初始Y轴位置
            endX:0, //最后X轴位置
            favMoved:false,  //是否有删除按钮出现
            lastIndex:null,
            pageConfig:{
                PageIndex:1,
                PageSize:10
            },
            pageCount:0,
            prevAjaxEnd:true
        }
    },
    mounted() {
        this.initData();
        this.$refs.scrollboxWrapper.addEventListener('scroll', this.scrollHandler,false)
    },
    methods: {
        scrollHandler(){
            let scrollTop = this.$refs.scrollboxWrapper.scrollTop
            let visible_h = this.$refs.scrollboxWrapper.clientHeight - document.querySelector('#navbar-fixed').clientHeight
            let scrollBox_h = this.$refs.scrollbox.clientHeight
            if (scrollTop + visible_h >= scrollBox_h) {
                this.loadMore()
            }
        },
        loadMore(){
                if (!this.prevAjaxEnd) return
                if (this.pageConfig.PageIndex >= this.pageCount) return
                this.prevAjaxEnd = false
                store.commit('SET_LOADING_POSITION','bottom')
                FAV.GetFavList({
                    PageIndex: ++this.pageConfig.PageIndex,
                    PageSize: this.pageConfig.PageSize
                }).then( (res) => {
                    if (res.Data != null) {
                        this.favList = this.favList.concat(res.Data.List)
                        this.prevAjaxEnd = true
                        store.commit('SET_LOADING_POSITION','middle')
                    }
                }).catch(()=>{
                    this.prevAjaxEnd = true
                    store.commit('SET_LOADING_POSITION','middle')
                })
        },
        initData(){
            this.favList = []
            this.scrollTop = 0
            this.pageConfig.PageIndex = 1
            this.pageCount = 0
            this.ajaxDone = false
            this.favMoved = false
            this.lastIndex = null

            FAV.GetFavList(this.pageConfig).then((res)=>{
                if(res.Data) {
                    this.favList = res.Data.List
                    this.pageCount = Math.ceil(res.Data.TotalCount / this.pageConfig.PageSize);
                };
                this.ajaxDone = true;
            })
        },
        goKBDetail(favs){
            let routeName = favs.Type == 1 ? 'knowledge' : 'faq'
            this.$router.push({
                name: routeName,
                params: {
                    uuid: favs.KBInfoId
                }
            })
        },
        UpdateFav(KBInfoId,index){
            FAV.UpdateFav({'KBInfoId':KBInfoId}).then((res)=>{
                if(res.Code == 200){
                    this.$refs.favs[index].style.transition = ''
                    this.$refs.favs[index].style.transform = 'translateX(0)'
                    this.favList.splice(index, 1);
                    this.favMoved = false
                }
            })
        },
        touchStart(index,e){
            e = e || event;
            if(e.touches.length == 1) {    //tounches类数组，等于1时表示此时有只有一只手指在触摸屏幕
                this.startX = e.touches[0].clientX  // 记录开始拖动位置
                this.startY = e.touches[0].clientY  // 记录开始拖动位置
                if(this.lastIndex != index) {
                    this.favMoved = false
                    this.lastIndex = index;
                }
                this.$refs.favs[index].style.transition = ''
                this.$refs.favs.map((e,i) =>{
                    if(i != index) e.style.transform = 'translateX(0)'
                })
            }

        },
        touchMove(index,e){
            e = e || event;
            if(e.touches.length == 1) {    //tounches类数组，等于1时表示此时有只有一只手指在触摸屏幕
                let moveX = e.touches[0].clientX - this.startX;
                let moveY = e.touches[0].clientY - this.startY;
                if (Math.abs(moveX) > Math.abs(moveY)) {
                    // 横向滑动大于竖向滑动
                    e.preventDefault()
                    // 禁止竖向默认滑动
                    if(!this.favMoved && moveX < 0 && moveX >= -67) {
                        this.$refs.favs[index].style.transform = 'translateX(' + moveX + 'px)'
                    }
                    if(this.favMoved && moveX > 0 && moveX <= 67) {
                        if(this.$refs.favs[index].style.transform.replace(/[^0-9]/ig,"") != 0)
                            this.$refs.favs[index].style.transform = 'translateX(' + (moveX - 67) + 'px)'
                    }
                }
            }
        },
        touchEnd(index,e){
            e = e || event;
            if(e.changedTouches.length == 1) {    //tounches类数组，等于1时表示此时有只有一只手指在触摸屏幕
                let favTransform = this.$refs.favs[index].style.transform.match(/\(([^)]*)p/)
                let difX = !!favTransform  ? 1 * favTransform[1] : 0; //当前收藏向左滑动的距离
                if(difX < 0 && difX > -30){
                // 如果向左拖动并且拖动距离小于30
                    this.$refs.favs[index].style.transform = 'translateX(0)'
                    this.favMoved = false;
                }else if(difX < -30){
                    // 如果向左拖动并且拖动距离大于30
                    this.$refs.favs[index].style.transform = 'translateX(-67px)'
                    this.favMoved = true;
                }
                this.$refs.favs[index].style.transition = 'all 0.3s ease'
            }
        }
    },
    watch: {
        "$route"(to,from){
            if(to.name !== 'favorites') return;
            this.$refs.scrollboxWrapper.scrollTop = this.scrollTop
            if(from.name === 'knowledge' || from.name === 'faq') return
            this.initData()
        }
    },
    beforeRouteLeave (to, from, next) {
        // this.$refs.scrollboxWrapper.removeEventListener('scroll', this.scrollHandler)
        this.scrollTop = this.$refs.scrollboxWrapper.scrollTop
        next()
    }
}
</script>
<style lang="scss" scoped>
    .fav-wrapper{
        height: 100%;
        width: j(750);
        overflow: scroll;
        box-sizing: border-box;
        padding: j(36) 0 j(98);
        margin: 0 auto;
        .favorite-title{
            font-size:j(48);
            font-weight:700;
            color:rgba(54,60,84,1);
            margin-bottom: j(56);
            box-sizing: border-box;
            padding-left: j(50);
        }
        .fav-list{
            // padding-bottom: j(98);
            .fav-list-item{
                width: 100%;
                position: relative;
                z-index: 1;
                overflow: hidden;
                &::after{
                    content: "";
                    position: absolute;
                    height: 1px ;
                    width: j(650);
                    background-color: #F0F1F2;
                    bottom: 0;
                    left: j(50);
                    z-index: 3;
                }
                .favs-container{
                    width: calc(10rem + 67px);
                    display: flex;
                    padding-bottom: 1px;
                    .favs{
                        width: j(750);
                        padding: j(40) j(50);
                        box-sizing: border-box;
                        background-color: rgba(255,255,255,1);
                        position: relative;
                        transform: translateX(0);
                    }
                    .fav-cancle{
                        width: 67px;
                        background-color: #EF7575;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #fff;
                        font-size: j(28);
                    }
                }
            }
            .fav-tit,.fav-content{
                font-size:j(28);
                color:rgba(54,60,84,1);
                overflow: hidden;
                text-overflow:ellipsis;
                word-break: break-word;
                display: -webkit-box;
                /*!autohomeer: off */
                -webkit-box-orient: vertical;
                /*autohomeer: on */
                -webkit-line-clamp: 2;
            }
            .fav-content{
                margin: j(20) 0 0;
                color: #696D7F;
            }
        }
        .fav-empty{
            padding-top: j(300);
            box-sizing: border-box;
            position: absolute;
            top:50%;
            left:50%;
            transform: translate(-50%,-35%);
            width: j(750);
            height: j(700);
            background: url('/static/images/empty/no-favorites.png') no-repeat;
            background-size: cover;
            text-align: center;
            font-size:j(32);
            font-weight:400;
            color:rgba(155,157,169,1);
        }
    }


</style>



// WEBPACK FOOTER //
// src/views/favorites/favorites.vue